module.exports = __webpack_public_path__ + "img/logo_22.d87b1296.png";